async function bondAggregatorRegisterAuctioneer(contracts, contractName, auctioneer) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.registerAuctioneer(auctioneer);
}

async function bondAggregatorGetAuctioneer(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.getAuctioneer(id);
}

async function bondAggregatorMarketPrice(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.marketPrice(id);
}

async function bondAggregatorMarketScale(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.marketScale(id);
}

async function bondAggregatorPayoutFor(contracts, contractName, amount, id, referrer) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.payoutFor(amount, id, referrer);
}

async function bondAggregatorMaxAmountAccepted(contracts, contractName, id, referrer) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.maxAmountAccepted(id, referrer);
}

async function bondAggregatorIsInstantSwap(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.isInstantSwap(id);
}

async function bondAggregatorIsLive(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.isLive(id);
}

async function bondAggregatorLiveMarketsBetween(contracts, contractName, firstIndex, lastIndex) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.liveMarketsBetween(firstIndex, lastIndex);
}

async function bondAggregatorLiveMarketsFor(contracts, contractName, token, isPayout) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.liveMarketsFor(token, isPayout);
}

async function bondAggregatorMarketsFor(contracts, contractName, payout, quote) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.marketsFor(payout, quote);
}

async function bondAggregatorFindMarketFor(contracts, contractName, payout, quote, amountIn, minAmountOut, maxExpiry) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.findMarketFor(payout, quote, amountIn, minAmountOut, maxExpiry);
}

async function bondAggregatorLiveMarketsBy(contracts, contractName, owner, firstIndex, lastIndex) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.liveMarketsBy(owner, firstIndex, lastIndex);
}

async function bondAggregatorClosingMarketsBetween(contracts, contractName, firstIndex, lastIndex) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.closingMarketsBetween(firstIndex, lastIndex);
}

async function bondAggregatorGetTeller(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.getTeller(id);
}

async function bondAggregatorCurrentCapacity(contracts, contractName, id) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.currentCapacity(id);
}

async function bondAggregatorGetAuctioneers(contracts, contractName) {
  const aggregator = contracts.getContractByName(contractName);
  return await aggregator.auctioneers();
}

module.exports = {
  bondAggregatorRegisterAuctioneer,
  bondAggregatorGetAuctioneer,
  bondAggregatorMarketPrice,
  bondAggregatorMarketScale,
  bondAggregatorPayoutFor,
  bondAggregatorMaxAmountAccepted,
  bondAggregatorIsInstantSwap,
  bondAggregatorIsLive,
  bondAggregatorLiveMarketsBetween,
  bondAggregatorLiveMarketsFor,
  bondAggregatorMarketsFor,
  bondAggregatorFindMarketFor,
  bondAggregatorLiveMarketsBy,
  bondAggregatorClosingMarketsBetween,
  bondAggregatorGetTeller,
  bondAggregatorCurrentCapacity,
  bondAggregatorGetAuctioneers,
};
